import { useContext, useRef } from "react";
import { log } from "utilities";
import { ConfigurationContext } from "contexts";

/**
 *  useLogger hook.
 */

export const useLogger = () => {
  let config = useContext(ConfigurationContext);

  let properties = {
    userId: config.userId,
    ComputerId: config.computerId ,
    SystemId: config.systemId,//,
    ReqSetId: config.requirementSetId,
    ReferrerId: config.referrerId, 
    // source: "detection-client-app",
  };

  let verbose = (msg, eventID) => {
    log.verbose(msg, { ...properties, eventID: eventID });
  };
  let debug = (msg, eventID) => {
    log.debug(msg, { ...properties, eventID: eventID });
  };
  let information = (msg, eventID) => {
    log.information(msg, { ...properties, eventID: eventID });
  };
  let warning = (msg, eventID) => {
    log.warning(msg, { ...properties, eventID: eventID });
  };
  let error = (msg, eventID) => {
    log.error(msg, { ...properties, eventID: eventID });
  };
  let fatal = (msg, eventID) => {
    log.fatal(msg, { ...properties, eventID: eventID });
  };

  return {
    verbose: verbose,
    debug: debug,
    information: information,
    warning: warning,
    error: error,
    fatal: fatal,
  };
};
